import {
  GET_SEASON_PASSES,
  GET_SEASON_PASS_FAIL,
  GET_SEASON_PASSES_SUCCESS,
  GET_SEASON_PASS_DETAIL,
  ADD_NEW_SEASON_PASS,
  ADD_SEASON_PASS_SUCCESS,
  ADD_SEASON_PASS_FAIL,
  UPDATE_SEASON_PASS,
  UPDATE_SEASON_PASS_SUCCESS,
  UPDATE_SEASON_PASS_FAIL,
  GET_SEASON_PASS_DETAIL_FAIL,
  GET_SEASON_PASS_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
  DELETE_SEASON_PASS,
  DELETE_SEASON_PASS_SUCCESS,
  DELETE_SEASON_PASS_FAIL,
} from "./actionTypes"

export const getSeasonPasses = payload => ({
  type: GET_SEASON_PASSES,
  payload,
})

export const getSeasonPassesSuccess = SeasonPasses => ({
  type: GET_SEASON_PASSES_SUCCESS,
  payload: SeasonPasses,
})

export const addNewSeasonPass = SeasonPass => ({
  type: ADD_NEW_SEASON_PASS,
  payload: SeasonPass,
})

export const addSeasonPassSuccess = SeasonPass => ({
  type: ADD_SEASON_PASS_SUCCESS,
  payload: SeasonPass,
})

export const addSeasonPassFail = error => ({
  type: ADD_SEASON_PASS_FAIL,
  payload: error,
})

export const updateSeasonPass = SeasonPass => ({
  type: UPDATE_SEASON_PASS,
  payload: SeasonPass,
})

export const updateSeasonPassSuccess = SeasonPass => ({
  type: UPDATE_SEASON_PASS_SUCCESS,
  payload: SeasonPass,
})

export const updateSeasonPassFail = error => ({
  type: UPDATE_SEASON_PASS_FAIL,
  payload: error,
})

export const getSeasonPassFail = error => ({
  type: GET_SEASON_PASS_FAIL,
  payload: error,
})

export const getSeasonPassDetail = SeasonPassId => ({
  type: GET_SEASON_PASS_DETAIL,
  SeasonPassId,
})

export const getSeasonPassDetailSuccess = SeasonPassDetails => ({
  type: GET_SEASON_PASS_DETAIL_SUCCESS,
  payload: SeasonPassDetails,
})

export const getSeasonPassDetailFail = error => ({
  type: GET_SEASON_PASS_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
export const deleteSeasonPass = SeasonPass => ({
  type: DELETE_SEASON_PASS,
  payload: SeasonPass,
})

export const deleteSeasonPassSuccess = SeasonPass => ({
  type: DELETE_SEASON_PASS_SUCCESS,
  payload: SeasonPass,
})

export const deleteSeasonPassFail = error => ({
  type: DELETE_SEASON_PASS_FAIL,
  payload: error,
})
